import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
}

export function Logo({ className }: LogoProps) {
  return (
    <img
      src="/logo.png"
      alt="Cerberus Security"
      className={cn("h-16 w-16 object-contain", className)}
    />
  );
}
